// Utils.jsx
import { FiLogOut } from "react-icons/fi";
import { FaMoon, FaSun, FaCalendarAlt, FaUser, FaBuilding, FaBook, FaMapMarkerAlt, FaComments, FaFileImport, FaBriefcase, FaTachometerAlt, FaClipboardList, FaProjectDiagram, FaEnvelope, FaFileExport, FaImage, FaThumbtack, FaEye, FaEyeSlash, FaSave, FaCheck, FaLink, FaUndo, FaRedo, FaTrash, FaArrowsAlt, FaTimes, FaCog, FaEdit, FaGraduationCap, FaClock, FaCopy, FaPhone, FaInfoCircle, FaFileWord } from "react-icons/fa";
import { AiFillThunderbolt } from "react-icons/ai";
import { TbFlag, TbFlagPlus, TbFlagMinus } from "react-icons/tb";
import Checkbox from './Checkbox';

// Phone number processing component
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import AccountSelector from './AccountSelector';
import ContactSelector from './ContactSelector';
import QuickEmail from './QuickEmail';
import axios from '../axiosConfig';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { parseDbDate } from '../utils/dates';

export const IconShowSlides = FaEye;
export const IconView = FaEye;
export const IconHideSlides = FaEyeSlash;
export const IconSave = FaSave;
export const IconTick = FaCheck;
export const IconLink = FaLink;
export const IconUndo = FaUndo;
export const IconRedo = FaRedo;
export const IconExport = FaFileExport;
export const IconClear = FaTrash;
export const IconX = FaTimes;
export const IconMove = FaArrowsAlt;
export const IconClock = FaClock;
export const IconCopy = FaCopy;
export const IconEdit = FaEdit;
// Flags: used on every flag button and flag filter across the site.
export const IconFlag = TbFlag;
export const IconFlagPlus = TbFlagPlus;
export const IconFlagMinus = TbFlagMinus;

export const countryCodes = [
  { code: "93", name: "Afghanistan" },
  { code: "355", name: "Albania" },
  { code: "213", name: "Algeria" },
  { code: "1684", name: "American Samoa" },
  { code: "376", name: "Andorra" },
  { code: "244", name: "Angola" },
  { code: "1264", name: "Anguilla" },
  { code: "1268", name: "Antigua and Barbuda" },
  { code: "54", name: "Argentina" },
  { code: "374", name: "Armenia" },
  { code: "297", name: "Aruba" },
  { code: "61", name: "Australia" },
  { code: "43", name: "Austria" },
  { code: "994", name: "Azerbaijan" },
  { code: "1242", name: "Bahamas" },
  { code: "973", name: "Bahrain" },
  { code: "880", name: "Bangladesh" },
  { code: "1246", name: "Barbados" },
  { code: "375", name: "Belarus" },
  { code: "32", name: "Belgium" },
  { code: "501", name: "Belize" },
  { code: "229", name: "Benin" },
  { code: "1441", name: "Bermuda" },
  { code: "975", name: "Bhutan" },
  { code: "591", name: "Bolivia" },
  { code: "387", name: "Bosnia and Herzegovina" },
  { code: "267", name: "Botswana" },
  { code: "55", name: "Brazil" },
  { code: "673", name: "Brunei" },
  { code: "359", name: "Bulgaria" },
  { code: "226", name: "Burkina Faso" },
  { code: "257", name: "Burundi" },
  { code: "855", name: "Cambodia" },
  { code: "237", name: "Cameroon" },
  { code: "1", name: "Canada" },
  { code: "1", name: "United States" },
  { code: "238", name: "Cape Verde" },
  { code: "1345", name: "Cayman Islands" },
  { code: "236", name: "Central African Republic" },
  { code: "235", name: "Chad" },
  { code: "56", name: "Chile" },
  { code: "86", name: "China" },
  { code: "57", name: "Colombia" },
  { code: "269", name: "Comoros" },
  { code: "242", name: "Congo" },
  { code: "243", name: "Congo (Democratic Republic)" },
  { code: "682", name: "Cook Islands" },
  { code: "506", name: "Costa Rica" },
  { code: "385", name: "Croatia" },
  { code: "53", name: "Cuba" },
  { code: "599", name: "Curaçao" },
  { code: "357", name: "Cyprus" },
  { code: "420", name: "Czech Republic" },
  { code: "225", name: "Côte d'Ivoire" },
  { code: "45", name: "Denmark" },
  { code: "253", name: "Djibouti" },
  { code: "1767", name: "Dominica" },
  { code: "1809", name: "Dominican Republic" },
  { code: "593", name: "Ecuador" },
  { code: "20", name: "Egypt" },
  { code: "503", name: "El Salvador" },
  { code: "240", name: "Equatorial Guinea" },
  { code: "291", name: "Eritrea" },
  { code: "372", name: "Estonia" },
  { code: "268", name: "Eswatini" },
  { code: "251", name: "Ethiopia" },
  { code: "500", name: "Falkland Islands" },
  { code: "298", name: "Faroe Islands" },
  { code: "679", name: "Fiji" },
  { code: "358", name: "Finland" },
  { code: "33", name: "France" },
  { code: "590", name: "French Guadeloupe" },
  { code: "590", name: "Saint Barthélemy" },
  { code: "590", name: "Saint Martin" },
  { code: "594", name: "French Guiana" },
  { code: "689", name: "French Polynesia" },
  { code: "241", name: "Gabon" },
  { code: "220", name: "Gambia" },
  { code: "995", name: "Georgia" },
  { code: "49", name: "Germany" },
  { code: "233", name: "Ghana" },
  { code: "350", name: "Gibraltar" },
  { code: "30", name: "Greece" },
  { code: "299", name: "Greenland" },
  { code: "1473", name: "Grenada" },
  { code: "1671", name: "Guam" },
  { code: "502", name: "Guatemala" },
  { code: "44", name: "United Kingdom" },
  { code: "44", name: "Guernsey" },
  { code: "44", name: "Jersey" },
  { code: "44", name: "Isle of Man" },
  { code: "224", name: "Guinea" },
  { code: "245", name: "Guinea-Bissau" },
  { code: "592", name: "Guyana" },
  { code: "509", name: "Haiti" },
  { code: "504", name: "Honduras" },
  { code: "852", name: "Hong Kong" },
  { code: "36", name: "Hungary" },
  { code: "354", name: "Iceland" },
  { code: "91", name: "India" },
  { code: "62", name: "Indonesia" },
  { code: "98", name: "Iran" },
  { code: "964", name: "Iraq" },
  { code: "353", name: "Ireland" },
  { code: "972", name: "Israel" },
  { code: "39", name: "Italy" },
  { code: "1876", name: "Jamaica" },
  { code: "81", name: "Japan" },
  { code: "962", name: "Jordan" },
  { code: "7", name: "Kazakhstan" },
  { code: "7", name: "Russia" },
  { code: "254", name: "Kenya" },
  { code: "686", name: "Kiribati" },
  { code: "850", name: "Korea (North)" },
  { code: "82", name: "Korea (South)" },
  { code: "965", name: "Kuwait" },
  { code: "996", name: "Kyrgyzstan" },
  { code: "856", name: "Laos" },
  { code: "371", name: "Latvia" },
  { code: "961", name: "Lebanon" },
  { code: "266", name: "Lesotho" },
  { code: "231", name: "Liberia" },
  { code: "218", name: "Libya" },
  { code: "423", name: "Liechtenstein" },
  { code: "370", name: "Lithuania" },
  { code: "352", name: "Luxembourg" },
  { code: "853", name: "Macao" },
  { code: "261", name: "Madagascar" },
  { code: "265", name: "Malawi" },
  { code: "60", name: "Malaysia" },
  { code: "960", name: "Maldives" },
  { code: "223", name: "Mali" },
  { code: "356", name: "Malta" },
  { code: "692", name: "Marshall Islands" },
  { code: "596", name: "Martinique" },
  { code: "222", name: "Mauritania" },
  { code: "230", name: "Mauritius" },
  { code: "262", name: "Mayotte" },
  { code: "262", name: "Réunion" },
  { code: "52", name: "Mexico" },
  { code: "691", name: "Micronesia" },
  { code: "373", name: "Moldova" },
  { code: "377", name: "Monaco" },
  { code: "976", name: "Mongolia" },
  { code: "382", name: "Montenegro" },
  { code: "1664", name: "Montserrat" },
  { code: "212", name: "Morocco" },
  { code: "212", name: "Western Sahara" },
  { code: "258", name: "Mozambique" },
  { code: "95", name: "Myanmar" },
  { code: "264", name: "Namibia" },
  { code: "674", name: "Nauru" },
  { code: "977", name: "Nepal" },
  { code: "31", name: "Netherlands" },
  { code: "687", name: "New Caledonia" },
  { code: "64", name: "New Zealand" },
  { code: "505", name: "Nicaragua" },
  { code: "227", name: "Niger" },
  { code: "234", name: "Nigeria" },
  { code: "683", name: "Niue" },
  { code: "672", name: "Norfolk Island" },
  { code: "389", name: "North Macedonia" },
  { code: "1670", name: "Northern Mariana Islands" },
  { code: "47", name: "Norway" },
  { code: "47", name: "Svalbard and Jan Mayen" },
  { code: "968", name: "Oman" },
  { code: "92", name: "Pakistan" },
  { code: "680", name: "Palau" },
  { code: "970", name: "Palestine" },
  { code: "507", name: "Panama" },
  { code: "675", name: "Papua New Guinea" },
  { code: "595", name: "Paraguay" },
  { code: "51", name: "Peru" },
  { code: "63", name: "Philippines" },
  { code: "48", name: "Poland" },
  { code: "351", name: "Portugal" },
  { code: "1787", name: "Puerto Rico" },
  { code: "974", name: "Qatar" },
  { code: "40", name: "Romania" },
  { code: "250", name: "Rwanda" },
  { code: "290", name: "Saint Helena" },
  { code: "1869", name: "Saint Kitts and Nevis" },
  { code: "1758", name: "Saint Lucia" },
  { code: "508", name: "Saint Pierre and Miquelon" },
  { code: "1784", name: "Saint Vincent and the Grenadines" },
  { code: "685", name: "Samoa" },
  { code: "378", name: "San Marino" },
  { code: "239", name: "São Tomé and Príncipe" },
  { code: "966", name: "Saudi Arabia" },
  { code: "221", name: "Senegal" },
  { code: "381", name: "Serbia" },
  { code: "248", name: "Seychelles" },
  { code: "232", name: "Sierra Leone" },
  { code: "65", name: "Singapore" },
  { code: "1721", name: "Sint Maarten" },
  { code: "421", name: "Slovakia" },
  { code: "386", name: "Slovenia" },
  { code: "677", name: "Solomon Islands" },
  { code: "252", name: "Somalia" },
  { code: "27", name: "South Africa" },
  { code: "211", name: "South Sudan" },
  { code: "34", name: "Spain" },
  { code: "94", name: "Sri Lanka" },
  { code: "249", name: "Sudan" },
  { code: "597", name: "Suriname" },
  { code: "46", name: "Sweden" },
  { code: "41", name: "Switzerland" },
  { code: "963", name: "Syria" },
  { code: "886", name: "Taiwan" },
  { code: "992", name: "Tajikistan" },
  { code: "255", name: "Tanzania" },
  { code: "66", name: "Thailand" },
  { code: "670", name: "Timor-Leste" },
  { code: "228", name: "Togo" },
  { code: "690", name: "Tokelau" },
  { code: "676", name: "Tonga" },
  { code: "1868", name: "Trinidad and Tobago" },
  { code: "216", name: "Tunisia" },
  { code: "90", name: "Turkey" },
  { code: "993", name: "Turkmenistan" },
  { code: "1649", name: "Turks and Caicos Islands" },
  { code: "688", name: "Tuvalu" },
  { code: "256", name: "Uganda" },
  { code: "380", name: "Ukraine" },
  { code: "971", name: "United Arab Emirates" },
  { code: "598", name: "Uruguay" },
  { code: "998", name: "Uzbekistan" },
  { code: "678", name: "Vanuatu" },
  { code: "379", name: "Vatican City" },
  { code: "58", name: "Venezuela" },
  { code: "84", name: "Vietnam" },
  { code: "1284", name: "Virgin Islands (British)" },
  { code: "1340", name: "Virgin Islands (US)" },
  { code: "681", name: "Wallis and Futuna" },
  { code: "967", name: "Yemen" },
  { code: "260", name: "Zambia" },
  { code: "263", name: "Zimbabwe" },
].sort((a, b) => a.name.localeCompare(b.name));

export function getCountryNameFromCode(code) {
  if (!code) {
    return ""; // nothing if code is nothing
  }
  const country = countryCodes.find(({code: c}) => c === code);
  return country ? country.name : "Unknown Country";
}

// Function to get grouped country codes (combines countries with same code)
export function getGroupedCountryCodes() {
  // Group countries by their code
  const grouped = countryCodes.reduce((acc, country) => {
    if (!acc[country.code]) {
      acc[country.code] = [];
    }
    acc[country.code].push(country.name);
    return acc;
  }, {});

  // Create multiple entries for each group, with each country taking a turn being first
  const result = [];
  
  Object.entries(grouped).forEach(([code, names]) => {
    if (names.length === 1) {
      // Single country, just add it once
      result.push({
        code,
        name: names[0]
      });
    } else {
      // Multiple countries, create an entry for each country being first
      names.forEach((primaryCountry, index) => {
        const otherCountries = names.filter((_, i) => i !== index);
        const combinedName = [primaryCountry, ...otherCountries].join(' / ');
        result.push({
          code,
          name: combinedName
        });
      });
    }
  });

  // Sort alphabetically by combined name
  return result.sort((a, b) => a.name.localeCompare(b.name));
}

// ─── Coded fields ───────────────────────────────────────────────────────────
// Database fields that store an integer code (account status, job stage,
// location type, ...) are sent and accepted by the backend as text labels. The
// allowed labels come from GET /field-options/ as { table: { column: [labels] } }
// and are loaded once per page load, then shared by every caller.
let fieldOptionsPromise = null;

export function useFieldOptions() {
  const [options, setOptions] = useState(null);
  useEffect(() => {
    if (!fieldOptionsPromise) {
      fieldOptionsPromise = axios.get('/field-options/').then((res) => res.data);
      fieldOptionsPromise.catch(() => { fieldOptionsPromise = null; });
    }
    let cancelled = false;
    fieldOptionsPromise
      .then((data) => { if (!cancelled) setOptions(data); })
      .catch((err) => console.error('Failed to load field options:', err));
    return () => { cancelled = true; };
  }, []);
  return options || {};
}

// [{ value, label }] dropdown options for one coded field, e.g.
// fieldOptionList(options, 'accounts', 'status').
export function fieldOptionList(options, table, column) {
  return (options?.[table]?.[column] || []).map((label) => ({ value: label, label }));
}

// accounts.results_month is a plain month number (1-12), not a coded field.
export const MONTH_LABELS = {
  1: 'January', 2: 'February', 3: 'March', 4: 'April', 5: 'May', 6: 'June',
  7: 'July', 8: 'August', 9: 'September', 10: 'October', 11: 'November', 12: 'December',
};

export const MONTH_OPTIONS = Object.entries(MONTH_LABELS).map(([value, label]) => ({ value, label }));

// ─── Locations ──────────────────────────────────────────────────────────────
// Locations have no name; they're identified by their address.
export function formatAddress(loc) {
  if (!loc) return '';
  return [
    loc.address_1, loc.address_2, loc.address_3, loc.address_4,
    loc.city, loc.county, loc.country, loc.postcode,
  ].filter(Boolean).join(', ');
}

// Short label for dropdowns/lists: first address line and city.
export function locationLabel(loc) {
  if (!loc) return '';
  return [loc.address_1, loc.city].filter(Boolean).join(', ') || `Location #${loc.id}`;
}

export const typeIcons = {
  sessions: <FaCalendarAlt className="nav-icon" />,
  session: <FaCalendarAlt className="type-icon" />,
  lead: <AiFillThunderbolt className="type-icon" />,
  contacts: <FaUser className="nav-icon" />,
  contact: <FaUser className="type-icon" />,
  accounts: <FaBook className="nav-icon" />,
  account: <FaBook className="type-icon" />,
  location: <FaMapMarkerAlt className="type-icon" />,
  interaction: <FaComments className="type-icon" />,
  import: <FaFileImport className="nav-icon" />,
  jobs: <FaBriefcase className="nav-icon" />,
  job: <FaBriefcase className="type-icon" />,
  dashboard: <FaTachometerAlt className="nav-icon" />,
  tasks: <FaClipboardList className="nav-icon" />,
  interactions: <FaComments className="nav-icon" />,
  slides: <FaImage className="nav-icon" />,
  programmebuilder: <FaProjectDiagram className="nav-icon" />,
  createhandouts: <FaFileWord className="nav-icon" />,
  elearning: <FaGraduationCap className="nav-icon" />,
  emailbuilder: <FaEnvelope className="nav-icon" />,
  export: <FaFileExport className="nav-icon" />,
  pin: <FaThumbtack className="pin-icon" />,
  settings: <FaCog className="nav-icon" />,
  flag: <TbFlag className="nav-icon" />,
  flagplus: <TbFlagPlus className="nav-icon" />,
};

export function getLocalDatetimeInputValue() {
  const now = new Date();
  const offset = now.getTimezoneOffset();
  const localDate = new Date(now.getTime() - offset * 60000);
  return localDate.toISOString().slice(0, 16);
}

export function toUTCISOString(localDatetimeStr) {
  const localDate = new Date(localDatetimeStr);
  return localDate.toISOString();
}

// A stored UTC date/time (see utils/dates.js) as a datetime-local input value.
export function toLocalISOString(utcDatetimeStr) {
  const date = parseDbDate(utcDatetimeStr);
  if (!date) return getLocalDatetimeInputValue();
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60000);
  return localDate.toISOString().slice(0, 16);
}

// Loose email check: something, '@', something, '.', something (no spaces).
export const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());

// ─── InlineEdit ─────────────────────────────────────────────────────────────
// Displays a value as plain text; on hover shows an edit button.
// When editing, renders the appropriate control based on `type`.
//
// Props:
//   value        – current value (for account/contact, the full object or ID)
//   field        – field name passed back to onSave
//   type         – 'text' | 'link' | 'email' | 'phone' | 'dropdown' | 'venue'
//                  | 'date' | 'account' | 'contact'
//   onSave       – (field, newValue) => void  — parent handles PATCH
//   options      – [{ value, label }] for dropdown/venue; defaults to Yes/No
//   placeholder  – shown when value is empty (default '—')
//   displayValue – overrides display text (useful when value is an ID)
//   style        – extra styles for the outer container
//   quickEmailParticipant – (type 'email' only) { id, type, first_name, last_name }
//                  of the person this address belongs to; when given, renders
//                  the QuickEmail send button next to the address
//   phoneCountry – (type 'phone' only) country name used to resolve the dial
//                  code for numbers stored without a leading '+' (e.g. switchboard
//                  numbers); used to build the tel: link/display and the editor value
//   contactAccountId / contactAccountIds – (type 'contact' only) limit the
//                  choices to contacts of that account / any of those accounts
//   validate     – (newValue) => error message | null; an error is shown under
//                  the editor and nothing is saved (type 'email' also checks
//                  isValidEmail)
export const InlineEdit = ({
  value,
  field,
  type = 'text',
  onSave,
  options,
  placeholder = '—',
  displayValue,
  style,
  quickEmailParticipant,
  phoneCountry,
  contactAccountId,
  contactAccountIds,
  disabled = false,
  disabled_reason,
  validate,
}) => {
  const [editing, setEditing] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [editValue, setEditValue] = useState(value ?? '');
  const [isNarrow, setIsNarrow] = useState(false);
  const [error, setError] = useState(null);
  const containerRef = useRef(null);
  const location = useLocation();
  const locationKeyRef = useRef(`${location.pathname}${location.search}`);

  // Keep editValue in sync when the external value changes (but not mid-edit)
  useEffect(() => {
    if (!editing) setEditValue(value ?? '');
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  // Cancel any in-progress edit when navigating away from the current page
  // (covers both full route changes and same-route param changes, e.g. ?id=1 -> ?id=2)
  useEffect(() => {
    const key = `${location.pathname}${location.search}`;
    if (key !== locationKeyRef.current) {
      locationKeyRef.current = key;
      setEditing(false);
      setHovered(false);
      setEditValue(value ?? '');
    }
  }, [location.pathname, location.search]); // eslint-disable-line react-hooks/exhaustive-deps

  // Below this width, push the confirm/cancel buttons onto their own line.
  const NARROW_BREAKPOINT = 200;
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const observer = new ResizeObserver((entries) => {
      const width = entries[0]?.contentRect?.width || 0;
      setIsNarrow(width < NARROW_BREAKPOINT);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const handleConfirm = () => {
    const newValue = type === 'email' ? String(editValue ?? '').trim() : editValue;
    const problem = (type === 'email' && newValue && !isValidEmail(newValue))
      ? 'Enter a valid email address, e.g. name@example.com'
      : (validate ? validate(newValue) : null);
    if (problem) {
      setError(problem);
      return;
    }
    setError(null);
    setEditing(false);
    setHovered(false);
    if (onSave) onSave(field, newValue);
  };

  const handleCancel = () => {
    setEditValue(value ?? '');
    setError(null);
    setEditing(false);
    setHovered(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleConfirm();
    if (e.key === 'Escape') handleCancel();
  };

  const resolvedOptions = options || [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
  ];

  // Resolve a tel: href/label for raw numbers, using phoneCountry's dial code
  // when the number doesn't already start with '+'.
  const getPhoneLink = (raw) => {
    const v = String(raw || '').trim();
    if (!v) return null;
    if (v.startsWith('+')) return { href: `tel:${v}`, label: v };
    const dial = countryCodes.find(c => c.name === phoneCountry)?.code || '';
    if (dial) return { href: `tel:+${dial}${v}`, label: `+${dial} ${v}` };
    return { href: `tel:${v}`, label: v };
  };

  const getPhoneInputValue = (raw) => {
    const v = String(raw || '').trim();
    if (!v) return '';
    if (v.startsWith('+')) return v;
    const dial = countryCodes.find(c => c.name === phoneCountry)?.code || '';
    const digits = v.replace(/\D/g, '');
    if (!digits) return '';
    return dial ? `+${dial}${digits}` : digits;
  };

  // ── Display mode ──────────────────────────────────────────────────────────
  const renderDisplay = () => {
    const disp = displayValue !== undefined ? displayValue : value;
    if (disp === null || disp === undefined || disp === '') {
      return <span style={{ color: '#aaa', fontStyle: 'italic' }}>{placeholder}</span>;
    }
    if (React.isValidElement(disp)) {
      return disp;
    }
    if (type === 'link') {
      const href = String(disp).startsWith('http') ? String(disp) : `https://${disp}`;
      return (
        <a href={href} target="_blank" rel="noopener noreferrer"
           onClick={e => e.stopPropagation()}>
          {disp}
        </a>
      );
    }
    if (type === 'phone') {
      const link = getPhoneLink(disp);
      if (!link) return <span style={{ color: '#aaa', fontStyle: 'italic' }}>{placeholder}</span>;
      return (
        <a href={link.href} onClick={e => e.stopPropagation()}>
          <FaPhone /> {link.label}
        </a>
      );
    }
    if (type === 'email') {
      if (quickEmailParticipant) {
        return (
          <span onClick={e => e.stopPropagation()}>
            <QuickEmail initialParticipants={[
              { ...quickEmailParticipant, email: String(disp), is_sender: false }
            ]} />
          </span>
        );
      }
      return (
        <a href={`mailto:${disp}`} onClick={e => e.stopPropagation()}>
          {disp}
        </a>
      );
    }
    return <span>{String(disp)}</span>;
  };

  // ── Edit mode ─────────────────────────────────────────────────────────────
  const inputStyle = { flex: 1, minWidth: 80, padding: '4px 8px', border: '1px solid #007bff', borderRadius: 4, fontSize: 14, outline: 'none' };

  const renderEditor = () => {
    if (type === 'account') {
      return (
        <div style={{ flex: 1, minWidth: 160 }}>
          <AccountSelector value={editValue} onChange={val => setEditValue(val)} />
        </div>
      );
    }
    if (type === 'contact') {
      return (
        <div style={{ flex: 1, minWidth: 160 }}>
          <ContactSelector value={editValue} onChange={val => setEditValue(val)} accountId={contactAccountId} accountIds={contactAccountIds} />
        </div>
      );
    }
    if (type === 'phone') {
      return (
        <PhoneInput
          international
          defaultCountry="GB"
          countryOptionsOrder={['GB', 'US', '|', '...']}
          value={getPhoneInputValue(editValue)}
          onChange={val => setEditValue(val || '')}
          style={{ flex: 1 }}
        />
      );
    }
    if (type === 'dropdown' || type === 'venue') {
      return (
        <select autoComplete="off"
          value={editValue ?? ''}
          onChange={e => setEditValue(e.target.value)}
          onKeyDown={e => e.key === 'Escape' && handleCancel()}
          autoFocus
          style={inputStyle}
        >
          <option value="">— Select —</option>
          {resolvedOptions.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      );
    }
    if (type === 'date') {
      return (
        <input autoComplete="off"
          type="date"
          value={editValue ?? ''}
          onChange={e => { setEditValue(e.target.value); setError(null); }}
          onKeyDown={handleKeyDown}
          autoFocus
          style={error ? { ...inputStyle, borderColor: '#d00' } : inputStyle}
        />
      );
    }
    // text, link, email
    return (
      <input autoComplete="off"
        type="text"
        value={editValue ?? ''}
        onChange={e => { setEditValue(e.target.value); setError(null); }}
        onKeyDown={handleKeyDown}
        autoFocus
        style={error ? { ...inputStyle, borderColor: '#d00' } : inputStyle}
      />
    );
  };

  // ── Styles ────────────────────────────────────────────────────────────────
  const iconBtnStyle = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '2px 4px',
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
    lineHeight: 1,
  };

  return (
    <span
      ref={containerRef}
      style={{ display: 'inline-flex', alignItems: 'center', width: editing ? '100%' : undefined, maxWidth: '100%', boxSizing: 'border-box', borderRadius: 3, background: (!editing && hovered) ? 'rgba(0,0,0,0.05)' : 'transparent', transition: 'background 0.15s', ...style }}
      onMouseEnter={() => !editing && setHovered(true)}
      onMouseLeave={() => !editing && setHovered(false)}
    >
      {editing ? (
        <span style={{
          display: 'inline-flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 6,
          maxWidth: '100%',
        }}>
          {renderEditor()}
          {/* Grouped so confirm/cancel wrap onto their own line together when space is tight */}
          <span style={{ display: 'inline-flex', gap: 6, flexShrink: 0, flexBasis: isNarrow ? '100%' : 'auto' }}>
            <button
              onClick={handleConfirm}
              title="Confirm"
              style={{ background: '#28a745', color: 'white', border: 'none', borderRadius: 4, padding: '3px 8px', cursor: 'pointer', fontSize: 13, flexShrink: 0 }}
            >
              ✓
            </button>
            <button
              onClick={handleCancel}
              title="Cancel"
              style={{ border: 'none', borderRadius: 4, padding: '3px 8px', cursor: 'pointer', fontSize: 13, flexShrink: 0 }}
            >
              ✕
            </button>
          </span>
          {error && (
            <span style={{ flexBasis: '100%', color: '#d00', fontSize: 12 }}>
              {error}
            </span>
          )}
        </span>
      ) : (
        <>
          <span style={{ minWidth: 0 }}>{renderDisplay()}</span>
          <button
            onClick={() => !disabled && setEditing(true)}
            disabled={disabled}
            title={disabled ? disabled_reason : 'Edit'}
            style={{
              ...iconBtnStyle,
              color: '#aaa',
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: hovered ? 1 : 0,
              transform: hovered ? 'scale(1)' : 'scale(0.7)',
              transformOrigin: 'left center',
              width: hovered ? 28 : 0,
              overflow: 'hidden',
              marginLeft: hovered ? 4 : 0,
              pointerEvents: hovered ? 'auto' : 'none',
              transition: 'opacity 0.12s, transform 0.12s, width 0.12s, margin 0.12s',
            }}
          >
            {disabled ? <FaInfoCircle size={16} /> : <FaEdit size={16} />}
          </button>
        </>
      )}
    </span>
  );
};

// ─── InlineEditCheckbox ─────────────────────────────────────────────────────
// A boolean field rendered as a plain checkbox that saves on toggle — no
// hover/edit-button/confirm step, unlike InlineEdit's dropdown yes/no.
//
// Accepts the raw stored value: true/false, 1/0, '1'/'0' or 'yes'/'no'. A null
// (or undefined/'') value means "not set" and is shown as an indeterminate box
// (a dash), so it isn't mistaken for "No"; clicking it sets Yes. There's no way
// back to null from the checkbox. onSave always receives true/false.
//
// Props:
//   value    – the stored boolean (see above)
//   field    – field name passed back to onSave
//   label    – optional text shown next to the checkbox
//   onSave   – (field, checked) => void | Promise
//   disabled – disables the checkbox
//   disabled_reason – tooltip shown when disabled
export const InlineEditCheckbox = ({ value, field, label, onSave, disabled = false, disabled_reason }) => {
  const [saving, setSaving] = useState(false);
  // The value just clicked, shown while onSave is in flight; afterwards the
  // `value` prop (updated by the parent on success) takes over again.
  const [pending, setPending] = useState(null);

  const isUnset = value === null || value === undefined || value === '';
  const stored = !isUnset && (value === true || value === 1 || value === '1' || String(value).toLowerCase() === 'yes' || String(value).toLowerCase() === 'true');
  const checked = pending !== null ? pending : stored;
  const indeterminate = pending === null && isUnset;

  const handleChange = async (e) => {
    const next = e.target.checked;
    setPending(next);
    setSaving(true);
    try {
      if (onSave) await onSave(field, next);
    } finally {
      setSaving(false);
      setPending(null);
    }
  };

  const title = disabled ? disabled_reason : (indeterminate ? 'Not set' : undefined);

  return (
    <span
      title={title}
      style={{ display: label ? 'flex' : 'inline-flex', alignItems: 'center', width: label ? '100%' : undefined, textAlign: 'left', opacity: saving ? 0.6 : 1 }}
    >
      <Checkbox
        checked={checked}
        indeterminate={indeterminate}
        onChange={handleChange}
        disabled={disabled || saving}
        aria-label={label ? undefined : field}
        label={label || undefined}
      />
    </span>
  );
};

